import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {FullLocationUi} from '../../../api/generated';
import {locationApi, RequestStatus} from "../../../api/apiConfiguration";
import {RootState} from "../../../app/store";

interface LocationState {
    location?: FullLocationUi
    locationRequestStatus: RequestStatus
}

const initialState: LocationState = {
    locationRequestStatus: RequestStatus.NONE
}

export const fetchLocationById = createAsyncThunk(
    'location/fetchLocationById',
    (publicId: string) => locationApi.getLocationById({publicId})
);

export const locationSlice = createSlice({
    name: 'location',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(fetchLocationById.fulfilled, (state, {payload}) => {
            state.location = payload;
            state.locationRequestStatus = RequestStatus.RESOLVED
        });
        builder.addCase(fetchLocationById.pending, (state) => {
            state.locationRequestStatus = RequestStatus.PENDING
        });
        builder.addCase(fetchLocationById.rejected, (state) => {
            state.locationRequestStatus = RequestStatus.REJECTED
        });
    }
})

export const _ = locationSlice.actions;

export const locationSelector = (state: RootState): FullLocationUi | undefined => state.location.location;
export const locationRequestStatusSelector = (state: RootState): RequestStatus => state.location.locationRequestStatus;
